module.exports = __webpack_public_path__ + "img/background.5cb573cd.png";